/* tslint:disable */
/* eslint-disable */
/**
 * Apideck
 * The Apideck OpenAPI Spec: SDK Optimized
 *
 * The version of the OpenAPI document: 10.13.0
 * Contact: support@apideck.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import { Raw, RawFromJSON, RawToJSON } from './Raw'
import {
  TrackingCategory,
  TrackingCategoryFromJSON,
  TrackingCategoryToJSON
} from './TrackingCategory'

/**
 *
 * @export
 * @interface GetTrackingCategoryResponse
 */
export interface GetTrackingCategoryResponse {
  /**
   * HTTP Response Status Code
   * @type {number}
   * @memberof GetTrackingCategoryResponse
   */
  status_code: number
  /**
   * HTTP Response Status
   * @type {string}
   * @memberof GetTrackingCategoryResponse
   */
  status: string
  /**
   * Apideck ID of service provider
   * @type {string}
   * @memberof GetTrackingCategoryResponse
   */
  service: string
  /**
   * Unified API resource name
   * @type {string}
   * @memberof GetTrackingCategoryResponse
   */
  resource: string
  /**
   * Operation performed
   * @type {string}
   * @memberof GetTrackingCategoryResponse
   */
  operation: string
  /**
   *
   * @type {TrackingCategory}
   * @memberof GetTrackingCategoryResponse
   */
  data: TrackingCategory
  /**
   *
   * @type {Raw}
   * @memberof GetTrackingCategoryResponse
   */
  _raw?: Raw | null
}

export function GetTrackingCategoryResponseFromJSON(json: any): GetTrackingCategoryResponse {
  return GetTrackingCategoryResponseFromJSONTyped(json, false)
}

export function GetTrackingCategoryResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetTrackingCategoryResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status_code: json['status_code'],
    status: json['status'],
    service: json['service'],
    resource: json['resource'],
    operation: json['operation'],
    data: TrackingCategoryFromJSON(json['data']),
    _raw: !exists(json, '_raw') ? undefined : RawFromJSON(json['_raw'])
  }
}

export function GetTrackingCategoryResponseToJSON(value?: GetTrackingCategoryResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status_code: value.status_code,
    status: value.status,
    service: value.service,
    resource: value.resource,
    operation: value.operation,
    data: TrackingCategoryToJSON(value.data),
    _raw: RawToJSON(value._raw)
  }
}
